export default __webpack_public_path__ + "static/media/i078hp.5dbb3f20.webp";